import React, { useState, useEffect } from "react";
import './work.css'



const Work = () => {
  const [activeCard, setActiveCard] = useState(0);

  const cards = [
    { id: 1,icon:"✒", title: "Branding", content: "Focus infographic venture business model canvas gamification ecosystem. Business plan gamification user experience low hanging fruit twitter. Metrics research & development market paradigm shift growth hacking disruptive user experience iPad social media angel investor alpha." },
    { id: 2,icon:"⌨", title: "Web Design", content: "Focus infographic venture business model canvas gamification ecosystem. Business plan gamification user experience low hanging fruit twitter. Metrics research & development market paradigm shift growth hacking disruptive user experience iPad social media angel investor alpha." },
    { id: 3,icon:"🗔", title: "Graphic Design", content: "Focus infographic venture business model canvas gamification ecosystem. Business plan gamification user experience low hanging fruit twitter. Metrics research & development market paradigm shift growth hacking disruptive user experience iPad social media angel investor alpha. " }
  ];

  useEffect(() => {
    const handleScroll = () => {
      let nextCard = activeCard;
      if (window.scrollY > window.innerHeight * (nextCard + 1)) {
        nextCard += 1;
      }
      setActiveCard(nextCard);
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [activeCard]);

  return (
    <div className="grid-container">
      {cards.map(card => (
        <div
          key={card.id}
          className={`grid-card ${activeCard >= card.id ? "active" : ""}`}
        >
          <div className="grid-card-icon">{card.icon}</div>
          <div className="grid-card-header">{card.title}</div>
          <div className="grid-card-body">{card.content}</div>
        </div>
      ))}
    </div>
  )
}

export default Work
